import { Button, Typography } from '@mui/material';
import { Box, styled } from '@mui/system';
import { useCallback, useEffect, useRef, useState } from 'react';
import { ProgressBackdrop } from 'packages/ui/src/components';
import ReactToPrint from 'react-to-print';
import { useLocation } from 'react-router-dom';
import RegisterForm from './RegisterForm';
import { CultivatedDeclarationTable } from './CultivatedDeclarationTable';
import { useRecoilValue } from 'recoil';
import { CommonDataState } from 'state/commonState';
import ReportApi from '../../api/ReportApi';
import ApiMapper from '../../constant/ApiMapper';
import { Report } from '@crops';

const mapper = ApiMapper.REPORT.DETAIL;

const DeclarationListPrintPage = () => {
  const [loading, setLoading] = useState(true);
  const printRef = useRef<HTMLDivElement>(null);
  const { regYear } = useRecoilValue(CommonDataState);

  const location = useLocation();

  const [user, setUser] = useState<Report.TUserDetail>();
  const [row, setRow] = useState<Report.TDetailList[]>();
  const [year, setYear] = useState('2023');

  useEffect(() => {}, []);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);

    const prjId = searchParams.get('prjId'); // id 취득
    const year = searchParams.get('year'); // count 취득
    const userIdnt = searchParams.get('userIdnt');

    setYear(year);
    callDetail(userIdnt);
    getDeclarationList(userIdnt, prjId);
    console.log(prjId);
    console.log(year);
  }, [location]);

  const getDeclarationList = async (userIdnt, prjId) => {
    try {
      const result = await ReportApi.DetailList({
        url: mapper.DETAIL_LIST,
        param: {
          userIdnt: userIdnt,
          prjId: prjId,
        },
      });
      if (result.length > 0) {
        console.log(result);
        setRow(result);
      }
    } catch (e) {
      console.error(e);
      throw e;
    } finally {
      setLoading(false);
    }
  };

  //신고자 정보
  const callDetail = async (id: string) => {
    try {
      if (!id) return;
      const tmp = await ReportApi.UserInfo({ url: mapper.USER_INFO, param: { userIdnt: id } });
      console.log(tmp);
      setUser(tmp);
    } catch (e) {
      console.log(e);
    }
  };

  const reactToPrintTrigger = useCallback(() => {
    return <Button variant="contained">출력하기</Button>;
  }, []);

  const handlePrint = useCallback(() => {
    return printRef.current;
  }, [printRef.current]);

  return (
    <>
      <ProgressBackdrop isLoading={loading} />
      <Box
        display="flex"
        justifyContent="flex-end"
        marginRight={6}
        marginTop={4}
        className="page-none"
      >
        <ReactToPrint
          trigger={reactToPrintTrigger}
          content={handlePrint}
        />
      </Box>
      <Wrapper ref={printRef}>
        <Box sx={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
          <Typography
            noWrap
            component="div"
            sx={{ fontWeight: '900', fontSize: '30pt', letterSpacing: '3px' }}
          >
            {year?.slice(2, 4)} ~ {(Number(year) + 1)?.toString().slice(2, 4)}년산 주요 채소류 재배면적 신고내역
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ fontWeight: 600 }}
          >
            신고자 정보
          </Typography>
        </Box>
        {user ? <RegisterForm userInfo={user} /> : null}
        <Typography
          variant="h6"
          noWrap
          component="div"
          sx={{ fontWeight: 600, marginTop: '20px' }}
        >
          신고내역
        </Typography>
        <CultivatedDeclarationTable
          rows={row}
          year={Number(year)}
        />
      </Wrapper>
    </>
  );
};

const Wrapper = styled('div')`
  height: 100% !important;
  padding: 30px;
  page-break-inside: avoid;
  page-break-after: auto;
  zoom: 70%;

  @media print {
    width: auto !important;
    height: auto !important;
    overflow: visible !important;
    margin-left: 0 !important;
    zoom: 70%;

    @page {
      size: A4;
      margin-top: 30px;
      margin-bottom: 40px;
    }

    .page-none {
      display: none;
    }
  }
`;

export default DeclarationListPrintPage;
